import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-hidden"
}
const _hoisted_3 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "cardbody" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center" }
const _hoisted_6 = { class: "flex flex-row-reverse items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "title" }, "Tasks", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.tableRow.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "filterButton flex",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "filterIcon"
                        }, null, -1),
                        _createTextVNode(" Filters ")
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode(_component_tableData, {
            class: "flex-1 min-h-0 table-section",
            tableRowData: _ctx.tableRow,
            headersData: _ctx.headers
          }, null, 8, ["tableRowData", "headersData"])
        ]))
      : _createCommentVNode("", true)
  ]))
}